import { createGlobalStyle, css } from 'styled-components';
import { LinkRoot } from '../../components/Link/Link.styles';
import { extractCssStylesFromStyledComponent } from '../../utils/extractCssStylesFromStyledComponent';
import { getComponentsLibraryVersionCssVariable } from '../getComponentsLibraryVersionCssVariable';
import { NORMALIZE_CSS } from '../normalizeCss';
import { REDUCED_MOTION_STYLES } from '../reducedMotionStyles';
export function extendBaseGlobalStylesWith(generateAdditionalStylesFromTheme) {
  return createGlobalStyle(["", " :root{", "}html,body,#app,#root{height:100%;margin:0;}html{padding:0;", ";}body{box-sizing:border-box;cursor:default;", "}*,*:before,*:after{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}.visually-hidden{position:absolute !important;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);}a{", "}a:link,a:visited{text-decoration:none;cursor:pointer;}button{-webkit-tap-highlight-color:transparent;}i{font-style:normal;}", " strong{font-weight:bold;}", ""], NORMALIZE_CSS, getComponentsLibraryVersionCssVariable(), _ref => {
    let {
      theme
    } = _ref;
    return css(["font-size:", "px;line-height:", "px;background:", ";color:", ";font-weight:", ";"], theme.Typography.DEFAULT_FONT_SIZE.p[0], theme.Typography.TEXT_TYPE_TO_LINE_HEIGHT_PX.p[0], theme.Main.primaryBackground, theme.Main.color, theme.Main.fontWeight);
  }, _ref2 => {
    let {
      theme
    } = _ref2;
    return `
    font-family: ${theme.fontFamilyPrimary};
    font-weight: ${theme.fontWeightPrimary};`;
  }, _ref3 => {
    let {
      theme
    } = _ref3;
    return extractCssStylesFromStyledComponent(LinkRoot, {
      theme: theme,
      variant: 'normal'
    });
  }, _ref4 => {
    let {
      theme
    } = _ref4;
    return generateAdditionalStylesFromTheme?.(theme);
  }, REDUCED_MOTION_STYLES);
}
export const GlobalStyles = extendBaseGlobalStylesWith();